import Vue from 'vue';
import Vuex from 'vuex'
import Vuetify from 'vuetify';
import App from './App.vue';
import ApiService from "@/api/index";
import router from './router';
import store from './store';
import config from '@/common/config';

import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.config.productionTip = false;
ApiService.init();
Vue.use(Vuetify);

Vue.axios.interceptors.response.use(
  response => response,           //If the request succeeds, we don't have to do anything and just return the response
  error => {
    //const errorResponse = error.response
    if (error.response.status === 401){
      store.dispatch("account/logoutUser");
      router.push('/login');
    };
    let isLoggedIn = store.getters.isLoggedIn() || false;
    if (!isLoggedIn){
      store.dispatch("account/logoutUser");
      //window.location = '/login';
      router.push('/login');
    }
    
    return Promise.reject(error)
  }
);

new Vue({
  router,
  store,
  vuetify: new Vuetify({
    theme: { dark: true },
    icons: {
      iconfont:  'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
  }),
  render: (h) => h(App),
}).$mount('#app');
